"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var calculate_1 = require("./calculate");
var helpers_1 = require("./helpers");
/**
 * calculate the hump, peak of amplification, region of our data. Determine if the hump region has more power than the background
 *
 * @param  {number[]} data
 * @param  {number} standardDeviationScalar
 * @param  {number} averageScalar
 * @param  {number} humpSideSize
 * @param  {number} backgroundLeft
 * @param  {boolean} useAfterHump
 * @param  {number} backgroundRight?
 * @returns DetectAmplificationD1
 */
function detectAmplificationD1(data, standardDeviationScalar, averageScalar, humpSideSize, backgroundLeft, useAfterHump, minBackgroundSize, backgroundRight) {
    var _a = calculate_1.determineD1Values(data), d1Data = _a.d1Data, d1MaxIndex = _a.d1MaxIndex;
    var humpLeftIndex = d1MaxIndex - humpSideSize;
    if (backgroundRight) {
        //Check to make sure we don't use part of the background as our hump
        if (humpLeftIndex <= backgroundRight)
            humpLeftIndex = backgroundRight;
    }
    var humpRightIndex = d1MaxIndex + humpSideSize;
    if (humpRightIndex >= data.length)
        humpRightIndex = data.length - 1;
    var backgroundSliceLeft = undefined;
    var backgroundSliceRight = undefined;
    var cQBackgroundLeft = 0;
    var cQBackgroundRight = 0;
    var cQBackgroundLeftExists = false;
    var cQBackgroundRightExists = false;
    var earlyAmp = false;
    if (humpLeftIndex <= backgroundLeft) {
        // hump at beginning, hump start at leftval and background set to the end
        humpLeftIndex = backgroundLeft;
        backgroundSliceLeft = humpRightIndex;
        backgroundSliceRight = data.length - 1;
        if (humpLeftIndex > minBackgroundSize - 1) {
            cQBackgroundLeft = humpLeftIndex - minBackgroundSize - 1;
            cQBackgroundLeftExists = true;
            cQBackgroundRight = humpLeftIndex;
            cQBackgroundRightExists = true;
        }
        else {
            console.log();
            cQBackgroundLeft = 0;
            cQBackgroundLeftExists = true;
            cQBackgroundRight = minBackgroundSize - 1;
            cQBackgroundRightExists = true;
        }
        earlyAmp = true;
    }
    else {
        // hump later on, background set to the beginning
        backgroundSliceLeft = backgroundLeft;
        backgroundSliceRight = humpLeftIndex;
        earlyAmp = false;
    }
    var d1Hump = d1Data.slice(humpLeftIndex, humpRightIndex);
    var d1Background = d1Data.slice(backgroundSliceLeft, backgroundSliceRight);
    if (useAfterHump) {
        d1Background = d1Background.concat(d1Data.slice(humpRightIndex, d1Data.length));
    }
    var d1HumpAverage = helpers_1.average(d1Hump);
    var d1BackgroundAverage = helpers_1.average(helpers_1.absoluteValues(d1Background));
    var d1BackgroundStandardDeviation = helpers_1.standardDeviation(d1Background);
    var d1Threshold = d1BackgroundAverage * averageScalar +
        d1BackgroundStandardDeviation * standardDeviationScalar;
    var didAmplify = d1HumpAverage > d1Threshold;
    if (cQBackgroundLeftExists) {
        backgroundSliceLeft = cQBackgroundLeft;
    }
    if (cQBackgroundRightExists) {
        backgroundSliceRight = cQBackgroundRight;
    }
    return {
        didAmplify: didAmplify,
        d1HumpAverage: d1HumpAverage,
        d1Threshold: d1Threshold,
        d1BackgroundLeft: backgroundSliceLeft,
        d1BackgroundRight: backgroundSliceRight,
        earlyAmp: earlyAmp
    };
}
exports.detectAmplificationD1 = detectAmplificationD1;
/**
 * take the filtered, minimum subtracted data calculate the threshold from the background region.
 * determine if data crosses that threshold and remains above the threshold
 *
 * @param  {number[]} data
 * @param  {number} thresholdScalar
 * @param  {number} backgroundLeft
 * @param  {number} backgroundRight
 * @returns CalculateThresholdAndCq
 */
function calculateThresholdAndCq(data, thresholdScalar, backgroundLeft, backgroundRight, algoThreshold) {
    var threshold;
    if (algoThreshold) {
        threshold = algoThreshold;
    }
    else {
        var backgroundThreshold = calculate_1.determineBackgroundThreshold(data, thresholdScalar, backgroundLeft, backgroundRight).backgroundThreshold;
        threshold = backgroundThreshold;
    }
    var cq = calculate_1.getCrossingPointIndex(data, threshold, 1, data.length);
    var didAmplify = false;
    if (0.0 < cq && cq <= data.length) {
        didAmplify = true;
    }
    return {
        cq: cq,
        baselineDidAmplify: didAmplify,
        threshold: threshold
    };
}
exports.calculateThresholdAndCq = calculateThresholdAndCq;
/**
 * Take the input cq value and transform by adding 1.
 * @param cq
 */
function transformCq(cq) {
    if (cq == 0) {
        return cq;
    }
    else {
        return cq + 1;
    }
}
exports.transformCq = transformCq;
/**
 * Transforms standard curve intercept to go from 0-indexed to 1-indexed by adding 1
 * @param intercept
 */
function transformIntercept(intercept) {
    var transformedIntercept = intercept + 1;
    return transformedIntercept;
}
exports.transformIntercept = transformIntercept;
